import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { HERO_BANNER_URL } from '../data/constants';
import { getWhatsAppUrl } from '../utils/whatsapp';
import { MessageCircle, Anchor } from 'lucide-react';
export const Hero = () => {
  const {
    t
  } = useLanguage();
  const handleWhatsAppClick = () => {
    const message = t('wa.help');
    window.open(getWhatsAppUrl(message), '_blank');
  };
  return <section id="inicio" className="relative min-h-[80vh] sm:min-h-[85vh] lg:min-h-screen flex items-end pb-10 sm:pb-14 lg:pb-24 bg-[#0A1F44] overflow-hidden" data-id="element-324">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-325">
        <img src={HERO_BANNER_URL} alt="Kevin Boats Torrevieja" loading="eager" fetchPriority="high" className="w-full h-full object-cover object-center" data-id="element-326" />
        {/* Soft dark vignette only at edges so headline stays readable */}
        <div className="absolute inset-0 bg-[#0A1F44]/25" data-id="element-327"></div>
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-b from-transparent to-[#0A1F44]" data-id="element-328"></div>
        <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-[#0A1F44]/60 to-transparent" data-id="element-329"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-330">
        <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8 leading-tight max-w-4xl mx-auto px-2" style={{
        textShadow: '0 2px 30px rgba(10, 31, 68, 0.7)'
      }} data-id="element-331">
          {t('hero.headline')}
        </h1>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-332">
          <a href="#barcos" className="w-full sm:w-auto bg-white text-navy hover:bg-gray-100 font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-full transition-all text-xs sm:text-sm uppercase tracking-wider flex items-center justify-center space-x-2" data-id="element-333">
            <Anchor className="w-5 h-5" data-id="element-334" />
            <span data-id="element-335">{t('hero.cta.primary')}</span>
          </a>

          <button onClick={handleWhatsAppClick} className="w-full sm:w-auto bg-turquoise hover:bg-turquoise-dark text-navy font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-full transition-all transform hover:scale-105 text-xs sm:text-sm uppercase tracking-wider flex items-center justify-center space-x-2 shadow-[0_0_30px_rgba(0,212,255,0.5)]" data-id="element-336">
            <MessageCircle className="w-5 h-5" data-id="element-337" />
            <span data-id="element-338">{t('hero.cta.secondary')}</span>
          </button>
        </div>
      </div>
    </section>;
};